import type { JSX } from 'react'

export const InfoIcon = (): JSX.Element => (
  <use href='#infoIcon' height='100%' width='100%' />
)
